import React, { Fragment } from 'react';
import { getPriceStripeAttributes } from '../../helpers/price.js';
import { PriceStripe as PriceStripe$1 } from './PriceStripe.styles.js';
import { EPriceSize, EPriceVariant } from '../PriceTag/PriceTag.types.js';
import { ScreenReader } from '../ScreenReader/ScreenReader.js';

var PriceStripe = function PriceStripe(_a) {
  var multiPrice = _a.multiPrice,
      _b = _a.size,
      size = _b === void 0 ? EPriceSize.MEDIUM : _b,
      unit = _a.unit,
      variant = _a.variant;

  var _c = getPriceStripeAttributes(size, variant),
      sizeAttributes = _c.sizeAttributes,
      variantAttributes = _c.variantAttributes;

  var isMultiPrice = multiPrice && multiPrice > 1;
  var stripeText = isMultiPrice ? "".concat(variant === EPriceVariant.KLIPP ? variant + ' ' : '').concat(multiPrice, " ").concat(unit === 'kg' ? unit : '', " f\xF6r") : variant;
  return React.createElement(Fragment, null, React.createElement(PriceStripe$1, {
    backgroundColor: variantAttributes.backgroundColor,
    fontColor: variantAttributes.fontColor,
    fontSize: sizeAttributes.fontSize
  }, stripeText), !!(variant === EPriceVariant.CAMPAIGN && isMultiPrice) && React.createElement(ScreenReader, {
    string: variant
  }));
};

export { PriceStripe };